@for (inputAttr of orderedInputAttributes(); track inputAttr) {
  @if (hasControl(inputAttr.name)) {
    @switch (inputAttr.valueType) {
      @case (1) {
        <forms-boolean-attribute
          [controlID]="inputAttr.name"
          [displayName]="inputAttr.displayName"
          [control]="getControl(inputAttr.name)"
          (cleared)="clearAttribute($event)"
        ></forms-boolean-attribute>
      }
      @case (2) {
        <forms-single-enum-attribute
          [controlID]="inputAttr.name"
          [displayName]="inputAttr.displayName"
          [selectOptions]="inputAttr.valueDisplayNames"
          [control]="getControl(inputAttr.name)"
          (cleared)="clearAttribute($event)"
        ></forms-single-enum-attribute>
      }
      @case (3) {
        <forms-url-attribute
          [controlID]="inputAttr.name"
          [displayName]="inputAttr.displayName"
          [control]="getControl(inputAttr.name)"
          (cleared)="clearAttribute($event)"
        ></forms-url-attribute>
      }
      @case (4) {
        <forms-repeated-enum-attribute
          [controlID]="inputAttr.name"
          [displayName]="inputAttr.displayName"
          [checkboxOptions]="inputAttr.valueDisplayNames"
          [formGroup]="getFormGroup(inputAttr.name)"
          (cleared)="clearAttribute($event)"
        ></forms-repeated-enum-attribute>
      }
      @default {
        <forms-text-attribute
          [controlID]="inputAttr.name"
          [displayName]="inputAttr.displayName"
          [control]="getControl(inputAttr.name)"
          (cleared)="clearAttribute($event)"
        ></forms-text-attribute>
      }
    }
  }
}
